import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export default function TestResultDialog({ open, onOpenChange, result }) {
  if (!result) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-surface-2 border-border rounded-sm max-w-lg">
        <DialogHeader>
          <DialogTitle>Test Result</DialogTitle>
          <DialogDescription>Dry-run result for portfolio rule</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <span className="text-xs text-muted-foreground font-semibold uppercase tracking-wider">
              Would Trigger:
            </span>
            <span
              className={`text-sm font-mono font-semibold ${
                result.would_trigger ? "text-profit" : "text-muted-foreground"
              }`}
            >
              {result.would_trigger ? "Yes" : "No"}
            </span>
          </div>

          {result.conditions && (
            <div>
              <div className="text-xs text-muted-foreground font-semibold uppercase tracking-wider mb-1">
                Conditions
              </div>
              <pre className="bg-surface-1 border border-border rounded-sm p-3 text-xs font-mono text-foreground overflow-x-auto max-h-48 overflow-y-auto">
                {JSON.stringify(result.conditions, null, 2)}
              </pre>
            </div>
          )}

          {result.projected_action && (
            <div>
              <div className="text-xs text-muted-foreground font-semibold uppercase tracking-wider mb-1">
                Projected Action
              </div>
              <pre className="bg-surface-1 border border-border rounded-sm p-3 text-xs font-mono text-foreground overflow-x-auto max-h-32 overflow-y-auto">
                {JSON.stringify(result.projected_action, null, 2)}
              </pre>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
